import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import {
  ProfileUserStoreInterface,
  UserProfileInterface,
  UserStoreInterface,
} from './types';
import { AuthService } from '@hrms/common/service';

export const initialUserState: UserProfileInterface = {
  userId: null,
  fullName: null,
  contact: null,
  emailId: null,
  roleName: null,
  isApproved: null,
  isBlacklisted: null,
  profileImageSource: null,
  tags: null,
  createdOn: null,
  roleID: null,
  isSuperUser: false,
};

const profileData: Array<string> = [
  'userId',
  'fullName',
  'contact',
  'emailId',
  'roleName',
  'isApproved',
  'isBlacklisted',
  'profileImageSource',
  'tags',
  'createdOn',
  'roleID',
  'isSuperUser',
];

const ProfileUserStore = create<ProfileUserStoreInterface>()(
  persist(
    (set) => ({
      isLoggedIn: AuthService.isLoggedIn(),
      userId: null,
      fullName: null,
      contact: null,
      emailId: null,
      roleName: null,
      isApproved: null,
      isBlacklisted: null,
      profileImageSource: null,
      tags: null,
      createdOn: null,
      allUsers: null,
      roleID: null,
      isSuperUser: false,
      setUserProfile: (profile) => {
        set((state) => {
          if (!profile) {
            return initialUserState;
          }
          const updatedState = { ...state } as any;

          for (const data of profileData as Array<keyof typeof profile>) {
            if (profile[data] !== undefined) {
              updatedState[data] = profile[data];
            }
          }
          return updatedState;
        });
      },

      setAllUsers: (users) => {
        set(() => ({
          allUsers: users,
        }));
      },
    }),
    {
      name: 'user-store',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        userId: state.userId,
        fullName: state.fullName,
        contact: state.contact,
        emailId: state.emailId,
        roleName: state.roleName,
        isApproved: state.isApproved,
        isBlacklisted: state.isBlacklisted,
        profileImageSource: state.profileImageSource,
        tags: state.tags,
        createdOn: state.createdOn,
        allUsers: state.allUsers,
        roleID: state.roleID,
        isSuperUser: state.isSuperUser,
      }),
    },
  ),
);

const UserStore = create<UserStoreInterface>()((set) => {
  return {
    isLoggedIn: AuthService.isLoggedIn(),
    setIsLoggedIn: (loggedIn) => {
      set(() => ({
        isLoggedIn: loggedIn,
      }));
    },
  };
});

export { UserStore, ProfileUserStore };
